/**
 * cart
 */

import $ from 'jquery';
import Vue from 'vue/dist/vue';
import Page from 'js/lib/page';

import cartItem from '~/cart-item/cart-item';
import store, { eventBus } from 'js/lib/Store';

//@ts-check

export default class Cart extends Page {
  init() {
    this.data = {
      isReady: false,
      hasDiscount: false,
      price: 0
    };

    this.elements();
    this.events();

    this.vm = this.vue();
  }
  vue() {
    const scope = this;

    return new Vue({
      el: this.$.root.get(0),
      data: this.data,
      computed: {
        amount() {
          return store.getters.productsAmount || 0;
        },
        products() {
          return store.state.products;
        },
        total() {
          const discount = this.hasDiscount ? 5 : 0;
          return this.products.reduce((acc, product) => {
            const cost = Number(product.amount) * Number(product.price);
            return acc + cost - (cost / 100) * discount;
          }, 0);
        }
      },
      store,
      components: {
        'cart-item': cartItem
      },
      mounted() {
        setTimeout(() => {
          this.isReady = true;
        }, 1000);
      }
    });
  }
}

Page.make(Cart, '.js-cart');
